import Actions from '../actions/location';
import { generateDefaultValidation, generateDefaultServerValidation } from '../utils/AddressUtil';

const mutators = {
    address1: (x) => x,
    address2: (x) => x,
    stateProvince: (x) => x,
    city: (x) => x,
    country: (x) => (x ? x.toUpperCase() : ''),
    postalCode: (x) => (x ? x.toUpperCase() : '')
};

const initialState = {
    address: {},
    addressValidation: generateDefaultValidation(),
    serverAddressValidation: generateDefaultServerValidation(),
    latLng: {},
    typeaheadPredictions: [],
    typeaheadQuery: undefined,
    geocoderValidation: {
        value: false,
        errorList: [],
        start: false,
        success: false,
        fail: false
    },
    geocoderLatLng: {
        value: {},
        threshold: null,
        error: '',
        start: false,
        success: false,
        fail: false
    },
    unitNumberValidation: {
        value: {
            missingUnitNumber: false,
            number: '',
            unitNumberValid: true
        },
        start: false,
        success: false,
        fail: false
    },
    propertyName: '',
    pinLocation: {},
    partialMatch: false
};

export default (state = initialState, action) => {
    switch (action.type) {
    case Actions.SET_PIN_LOCATION:
        return {
            ...state,
            pinLocation: action.latLng
        };
    case Actions.SERVER_VALIDATION_SET:
        return {
            ...state,
            serverAddressValidation: {
                ...state.serverAddressValidation,
                ...action.validation
            }
        };
    case Actions.SERVER_VALIDATION_CLEAR:
        return {
            ...state,
            serverAddressValidation: generateDefaultServerValidation()
        };
    case Actions.VALIDATE_GEOCODER_CLEAR:
        return {
            ...state,
            geocoderValidation: {
                value: false,
                errorList: [],
                start: false,
                success: false,
                fail: false
            }
        };
    case Actions.VALIDATE_GEOCODER_START:
        return {
            ...state,
            geocoderValidation: {
                value: false,
                errorList: [],
                start: true,
                success: false,
                fail: false
            }
        };
    case Actions.VALIDATE_GEOCODER_FAIL:
        return {
            ...state,
            geocoderValidation: {
                value: false,
                errorList: action.errorList,
                start: false,
                success: false,
                fail: true
            }
        };

    case Actions.VALIDATE_GEOCODER_SUCCESS:
        return {
            ...state,
            geocoderValidation: {
                value: action.value,
                errorList: action.errorList,
                start: false,
                success: true,
                fail: false
            }
        };
    case Actions.GEOCODER_LAT_LNG_CLEAR:
        return {
            ...state,
            latLng: {},
            pinLocation: {},
            geocoderLatLng: {
                value: {},
                threshold: null,
                start: false,
                success: false,
                fail: false
            }
        };
    case Actions.GEOCODER_LAT_LNG_START:
        return {
            ...state,
            latLng: {},
            geocoderLatLng: {
                value: {},
                threshold: null,
                error: '',
                start: true,
                success: false,
                fail: false
            }
        };
    case Actions.GEOCODER_LAT_LNG_FAIL:
        return {
            ...state,
            latLng: {},
            pinLocation: {},
            geocoderLatLng: {
                value: {},
                threshold: null,
                error: action.error,
                start: false,
                success: false,
                fail: true
            }
        };
    case Actions.SET_PARTIAL_MATCH:
        return {
            ...state,
            partialMatch: action.partialMatch
        };
    case Actions.GEOCODER_LAT_LNG_SUCCESS:
        return {
            ...state,
            latLng: action.value,
            geocoderLatLng: {
                value: action.value,
                error: action.error,
                threshold: action.threshold,
                start: false,
                success: true,
                fail: false
            }
        };
    case Actions.VALIDATE_UNIT_NUMBER_START:
        return {
            ...state,
            unitNumberValidation: {
                value: {
                    missingUnitNumber: false,
                    number: '',
                    unitNumberValid: true
                },
                start: true,
                success: false,
                fail: false
            }
        };
    case Actions.VALIDATE_UNIT_NUMBER_FAIL:
        return {
            ...state,
            unitNumberValidation: {
                value: {
                    missingUnitNumber: false,
                    unitNumberValid: true,
                    number: ''
                },
                start: false,
                success: false,
                fail: true
            }
        };
    case Actions.VALIDATE_UNIT_NUMBER_SUCCESS:
        return {
            ...state,
            unitNumberValidation: {
                value: action.value,
                start: false,
                success: true,
                fail: false
            }
        };
    case Actions.VALIDATE_UNIT_NUMBER_CLEAR:
        return {
            ...state,
            unitNumberValidation: {
                value: {
                    missingUnitNumber: false,
                    unitNumberValid: true,
                    number: ''
                },
                start: false,
                success: false,
                fail: false
            }
        };
    case Actions.SET_ADDRESS_FIELD:
        return {
            ...state,
            address: {
                ...state.address,
                [`${action.field}`]: mutators[action.field](action.value)
            }
        };
    case Actions.SET_ADDRESS_VALIDATION:
        return {
            ...state,
            addressValidation: action.validation
        };
    case Actions.SET_LAT_LNG:
        return { ...state, latLng: action.latLng };
    case Actions.SET_TYPEAHEAD_PREDICTIONS:
        return { ...state, typeaheadPredictions: action.predictions };
    case Actions.SET_TYPEAHEAD_QUERY:
        return { ...state, typeaheadQuery: action.query };
    case Actions.CLEAR_ADDRESS_VALIDATION:
        return ({
            ...state,
            addressValidation: generateDefaultValidation()
        });
    case Actions.CLEAR_ADDRESS_FIELDS:
        return ({
            ...state,
            address: {
                address1: '',
                address2: '',
                city: '',
                stateProvince: '',
                postalCode: ''
            }
        });
    case Actions.CLEAR_PROPERTY_NAME:
        return {
            ...state,
            propertyName: ''
        };
    case Actions.SET_PROPERTY_NAME:
        return {
            ...state,
            propertyName: action.name
        };
    default:
        return state;
    }
};
